import ChevronRightIcon from "@mui/icons-material/ChevronRightRounded";
import { Box, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import type { DetailColumn, ReportColumn, ReportRow } from "../../../../api/types/widgetTypes";
import TabularReportCellIcon from "../TabularReportCellIcon";
import TabularReportCellDetailsDrawer from "./TabularReportCellDetailsDrawer";
import { getCellValuesForReportRow } from "./tabularReportCellValuesHelper";
import TabularReportCellValuesList from "./TabularReportCellValuesList";

interface Props {
  row: ReportRow;
  columns: ReportColumn[];
  columnsLimit?: number;
  detailColumns?: DetailColumn[];
}

const TabularReportListItemContent = ({ row, columns, columnsLimit, detailColumns }: Props) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const cellValues = useMemo(
    () => getCellValuesForReportRow(row, columnsLimit ? columns.slice(0, columnsLimit) : columns),
    [row, columns, columnsLimit]
  );

  const handleShowDetails = () => setDrawerOpen(true);
  const handleHideDetails = () => setDrawerOpen(false);

  const firstCellValue = cellValues[0];

  const isOpeningDetailsEnabled = !!row.detailRows?.length || (!!columnsLimit && columns.length > columnsLimit);

  if (firstCellValue === undefined) {
    return null;
  }

  return (
    <>
      <Stack spacing={1} sx={{ minWidth: 0, py: 1.5, width: "100%" }}>
        <Box
          onClick={isOpeningDetailsEnabled ? handleShowDetails : undefined}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minWidth: 0,
            maxWidth: "100%",
            pb: 1,
          }}
        >
          <Stack direction="row" sx={{ alignItems: "center", width: "100%" }}>
            {firstCellValue.cell?.startIcon && <TabularReportCellIcon icon={firstCellValue.cell.startIcon} />}
            <Typography variant="subtitle1" sx={{ flex: 1, minWidth: 0, width: 0 }}>
              {firstCellValue.cell?.formattedValue || "-"}
            </Typography>
          </Stack>

          {isOpeningDetailsEnabled && <ChevronRightIcon />}
        </Box>

        {firstCellValue.cell?.subValue && (
          <Typography variant="body2" color="textSecondary">
            {firstCellValue.cell.subValue}
          </Typography>
        )}

        <TabularReportCellValuesList cellValues={cellValues.slice(1)} />
      </Stack>
      <TabularReportCellDetailsDrawer
        open={drawerOpen}
        onClose={handleHideDetails}
        row={row}
        columns={columns}
        detailColumns={detailColumns}
      />
    </>
  );
};

export default TabularReportListItemContent;
